var ContentSourceType = /* @__PURE__ */ ((ContentSourceType2) => {
  ContentSourceType2[ContentSourceType2["LIVE"] = 1] = "LIVE";
  ContentSourceType2[ContentSourceType2["VOD"] = 2] = "VOD";
  return ContentSourceType2;
})(ContentSourceType || {});
var ContentType = /* @__PURE__ */ ((ContentType2) => {
  ContentType2["CHANNEL"] = "LIVE";
  ContentType2["SERIE"] = "SERIE";
  ContentType2["MOVIE"] = "MOVIE";
  ContentType2["EPISODE"] = "EPISODE";
  ContentType2["EVENT"] = "SHOW";
  ContentType2["SPORT"] = "SPORT";
  return ContentType2;
})(ContentType || {});
var DrmQuality = /* @__PURE__ */ ((DrmQuality2) => {
  DrmQuality2["LOW_LATENCY"] = "LL-HD";
  DrmQuality2["DEFAULT"] = "SD-HD";
  return DrmQuality2;
})(DrmQuality || {});

export { ContentSourceType, ContentType, DrmQuality };
//# sourceMappingURL=types.js.map
